// /pages/FleetManagement/Trucks/CreateTruckPage.tsx

import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { useThemeColors } from '@/hooks/useThemeColors';
// ✅ Import the new TruckForm component
import { TruckForm } from '@/components/forms/TruckForm'; 

export default function CreateTruckPage() {
    const colors = useThemeColors();
    const navigate = useNavigate();
    
    // The success handler redirects back to the list page
    const handleSuccess = () => {
        navigate('/fleet-management/trucks');
    };

    // The cancel handler redirects back to the list page
    const handleCancel = () => {
        navigate('/fleet-management/trucks');
    };

    return (
        <AdminLayout>
            {/* The outer box pattern for full height and scrollability */}
            <Box p={4} h="100%" overflow="auto">
                <Card>
                    {/* Header Pattern */}
                    <CardHeader py={3}> 
                        <Heading size="md" mb={1}>
                            Create Truck
                        </Heading>
                        <Text fontSize="sm" color={colors.text}>
                            Add a new truck to the fleet.
                        </Text>
                    </CardHeader>
                    
                    {/* Body contains the form, matching the User pattern */}
                    <CardBody>
                        <TruckForm onSuccess={handleSuccess} onCancel={handleCancel} />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
}